export default __webpack_public_path__ + "static/media/alice-smith.8a3abecf.png";